export const tabPaths = {
  localization: ['description', 'name', 'title'],
  nutritionalInfo: ['alcohol', 'calories', 'sodium', 'nutritionInfo'],
  modifiers: ['modifierGroupIds', 'modifierGroupContextData'],
  upsell: ['upsell'],
  tags: ['tags'],
};
